import * as Config from '../../../config';
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

import ListColumns from '../content/list/ListColumns';
import InfosRecommendations from '../recommendation/InfosRecommendations';

import useGetRecs from './hooks/useGetRecs';

// let rcount = 0;
function RecommendationFromList({ listID, from, width, isCuration = false, onLoaded = null }) {
  const [tracks, setTracks] = useState([]);
  const stack = useSelector(state => state.stackAutomix);
  const loadedRef = useRef(false);

  useEffect(() => {
    loadedRef.current = false; // reset si on change de playlist
  }, [listID])

  useEffect(() => {
    if (loadedRef.current) return;
    if (listID) {
      let data = (Array.isArray(stack)) ? stack.find( x => x.idPlaylist === listID ) : ((stack.idPlaylist === listID) ? stack : null)
      if (data && data.tracks) {
        loadedRef.current = true;
        setTracks(data.tracks.map(x => x.id)); /*.slice(0, 10);*/
      }
    }
  }, [listID, stack])


  // Limit to 5 (Hardcode - No pagination with per_page for now)
  // TODO - Remove when pagination on API available.
  // useEffect(() => {
  //   rcount = 0;
  // }, [])
  // const recommendationFormatData = (data) => {
  //   const limit = 5;
  //   const base = rcount * limit;
  //   rcount++;
  //   return data.slice(base, base + 5).map(Config.formattedFromRecommendation(true));
  // }

  // ONE REQUEST - OPTIMISATION
  const oneRequestPath = (tracks && tracks.length > 0) ? `/catalog/v1/recommendations/tracks/?id=${tracks.join(',')}` : null;
  const { items: oneRequestStore } = useGetRecs(oneRequestPath);

  useEffect(() => {
    if (onLoaded && oneRequestStore) onLoaded();
  }, [oneRequestStore, onLoaded])

  return (tracks && tracks.length > 0 && oneRequestStore) ? (
    <ListColumns
      title={'Recommendations'}
      pathApi={null/*`/catalog/v1/recommendations/tracks/?id=${tracks.join(',')}`*/}
      oneRequestStore={oneRequestStore}
      customFormatData={null/*recommendationFormatData*/}
      id={`recommended-tracks-from-${from}`}
      width={width}
      height={(Config.LIST_ROW_HEIGHT * 5)}
      size={Config.LIST_ROW_HEIGHT}
      columnCount={2}
      rowCount={5}
      rowType={`Column`}
      hasPagination={true} allTo={`/home`} allLabel={``} paginationLimit={190}
      enableArrows={true}
      style={{paddingBottom: 30}}
      from={from}
      cache={false}
    >
      { Config.MOD_FEEDBACK && <InfosRecommendations force={true} className={'icon-next-to-list'} isCuration={isCuration} /> }
    </ListColumns>
  ) : null
}

RecommendationFromList.propTypes = {
  listID: PropTypes.any.isRequired,
  from: PropTypes.string.isRequired,
  width: PropTypes.any,
  onLoaded: PropTypes.func
}

export default RecommendationFromList;
